var map = {
	"./chat/index.js": "39350",
	"./conga/index.js": "4021",
	"./crypto/index.js": "efc1",
	"./games/case-battles/index.js": "4c47",
	"./games/cases/index.js": "3936",
	"./games/coinflip/index.js": "e0ed",
	"./games/dice/index.js": "7087",
	"./games/spinners/index.js": "c080",
	"./games/wheel/index.js": "fde2",
	"./index.js": "2a74",
	"./items/index.js": "289b",
	"./settings/index.js": "bccc",
	"./user/index.js": "6fec",
	"./winfeed/index.js": "1960"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "314a";